<template>
  <div :class="_class">
    <!-- @slot @ignore -->
    <slot />
  </div>
</template>
<script>
const name = 'ten-checkbox-group';
export default {
  name,
  provide() {
    return {
      group: this,
    };
  },
  inject: {
    formItem: {
      from: 'tenFormItem',
      default: null,
    },
  },
  props: {
    /**
     * 是否禁用
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * 选中元素列表
     */
    value: {
      type: Array,
      default: () => [],
    },
    /**
     * @model
     *
     * 默认选中元素列表
     */
    defaultValue: Array,
  },
  computed: {
    _class() {
      return [`${name}`];
    },
  },
  mounted() {
    this.$on('memberChange', this.onMemberChange);
  },
  methods: {
    onMemberChange({ value, checked }) {
      let newValue;
      const index = this.value.indexOf(value);
      if (checked) {
        if (index === -1) {
          newValue = [...this.value, value];
        } else {
          newValue = [...this.value];
        }
      } else {
        newValue = this.value.filter(item => item !== value);
      }

      /**
       * 选中值发生变化
       * @param { value } 选中值
       */
      this.$emit('change', newValue);
      this.formItem && this.formItem.$emit('form.change');
    },
  },
};
</script>
